/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintOrderVo
 */
export interface PrintOrderVo {
    /**
     * 接收人姓名
     * @type {string}
     * @memberof PrintOrderVo
     */
    receiverName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof PrintOrderVo
     */
    userCode?: string;
    /**
     * 通关码
     * @type {string}
     * @memberof PrintOrderVo
     */
    ctmsNo?: string;
    /**
     * 订单编号
     * @type {string}
     * @memberof PrintOrderVo
     */
    orderCode?: string;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof PrintOrderVo
     */
    additionalServiceNames?: string;
    /**
     * 备注
     * @type {string}
     * @memberof PrintOrderVo
     */
    remark?: string;
    /**
     * 国际运输运单号
     * @type {string}
     * @memberof PrintOrderVo
     */
    ivcNo?: string;
    /**
     * 国际运输方式：1海运 2空运 3LCL海运 4FCL海运
     * @type {number}
     * @memberof PrintOrderVo
     */
    internationalTransportMethodId?: number;
    /**
     * 运单打印页路径码：k空运面单 t海运面单
     * 运单打印页路径码：k空运 t海运
     * @type {string}
     * @memberof PrintOrderVo
     */
    waybillPrintTemplate?: string;
}

/**
 * Check if a given object implements the PrintOrderVo interface.
 */
export function instanceOfPrintOrderVo(value: object): value is PrintOrderVo {
    return true;
}

export function PrintOrderVoFromJSON(json: any): PrintOrderVo {
    return PrintOrderVoFromJSONTyped(json, false);
}

export function PrintOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'additionalServiceNames': json['additionalServiceNames'] == null ? undefined : json['additionalServiceNames'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'ivcNo': json['ivcNo'] == null ? undefined : json['ivcNo'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'waybillPrintTemplate': json['waybillPrintTemplate'] == null ? undefined : json['waybillPrintTemplate'],
    };
}

export function PrintOrderVoToJSON(json: any): PrintOrderVo {
    return PrintOrderVoToJSONTyped(json, false);
}

export function PrintOrderVoToJSONTyped(value?: PrintOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiverName': value['receiverName'],
        'userCode': value['userCode'],
        'ctmsNo': value['ctmsNo'],
        'orderCode': value['orderCode'],
        'additionalServiceNames': value['additionalServiceNames'],
        'remark': value['remark'],
        'ivcNo': value['ivcNo'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'waybillPrintTemplate': value['waybillPrintTemplate'],
    };
}

